import React from 'react';
import { Form, Input, Button, message, Row, Col, Card } from 'antd';
import { PlusCircleOutlined, ArrowLeftOutlined, DatabaseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAddServerMutation } from '../store/api';

const initialValues = {
  nombre: '', ip: '', cliente: '', disco: '', espaciolibre: '',
  carga: '', fechavencimiento: '', descripcion_detallada: '', whm_user: '', whm_api_token: '',
  mysql_user: '', mysql_pass: '', mysql_port: '3306',
};

export default function AgregarServidor() {
  const [addServer, { isLoading }] = useAddServerMutation();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      await addServer(values).unwrap();
      message.success('Servidor creado correctamente');
      navigate('/lista');
    } catch {
      message.error('Error al crear el servidor');
    }
  };

  return (
    <div className="page-container fade-in">
      <div className="page-header">
        <div className="page-header-left">
          <h1 className="page-title"><PlusCircleOutlined style={{ marginRight: 8 }} />Agregar Servidor</h1>
          <div className="page-subtitle">Registrar un nuevo servidor</div>
        </div>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/lista')} style={{ borderRadius: 8 }}>Volver</Button>
      </div>
      <Card bordered={false} style={{ borderRadius: 12, maxWidth: 700 }}>
        <Form layout="vertical" initialValues={initialValues} onFinish={onFinish}>
          <Form.Item label="Nombre" name="nombre" rules={[{ required: true, message: 'Ingrese el nombre' }]}><Input /></Form.Item>
          <Row gutter={16}>
            <Col span={12}><Form.Item label="IP" name="ip" rules={[{ required: true }]}><Input /></Form.Item></Col>
            <Col span={12}><Form.Item label="Cliente" name="cliente" rules={[{ required: true }]}><Input /></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}><Form.Item label="Disco Total (ej: 400G)" name="disco" rules={[{ required: true }]}><Input /></Form.Item></Col>
            <Col span={12}><Form.Item label="Espacio Libre (ej: 148G)" name="espaciolibre" rules={[{ required: true }]}><Input /></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}><Form.Item label="Carga Promedio" name="carga" rules={[{ required: true }]}><Input /></Form.Item></Col>
            <Col span={12}><Form.Item label="Próximo Pago" name="fechavencimiento" rules={[{ required: true }]}><Input type="date" /></Form.Item></Col>
          </Row>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#94a3b8', marginTop: 12, marginBottom: 12, textTransform: 'uppercase', letterSpacing: '.5px' }}>Credenciales WHM (opcional)</div>
          <Row gutter={16}>
            <Col span={12}><Form.Item label="Usuario WHM" name="whm_user"><Input placeholder="root" /></Form.Item></Col>
            <Col span={12}><Form.Item label="Token API WHM" name="whm_api_token"><Input.Password placeholder="Token API" /></Form.Item></Col>
          </Row>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#94a3b8', marginTop: 12, marginBottom: 12, textTransform: 'uppercase', letterSpacing: '.5px' }}><DatabaseOutlined style={{ marginRight: 6 }} />Credenciales MySQL (opcional)</div>
          <Row gutter={16}>
            <Col span={8}><Form.Item label="Usuario MySQL" name="mysql_user"><Input placeholder="root" /></Form.Item></Col>
            <Col span={8}><Form.Item label="Password MySQL" name="mysql_pass"><Input.Password placeholder="Password" /></Form.Item></Col>
            <Col span={8}><Form.Item label="Puerto MySQL" name="mysql_port"><Input placeholder="3306" type="number" /></Form.Item></Col>
          </Row>
          <Form.Item label="Descripción operativa" name="descripcion_detallada"
            extra="Servicios que presta, APIs expuestas y contenido general (formato lista con •)">
            <Input.TextArea rows={6} placeholder="• Rol: ...&#10;• Servicios internos: ...&#10;• Expone: ...&#10;• Contenido: ..." />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={isLoading} block
              style={{ borderRadius: 8, fontWeight: 600, height: 44, background: 'linear-gradient(135deg, #845adf, #6c3fc5)', border: 'none' }}>
              Guardar Servidor
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
